import { makeStyles } from "@material-ui/core";


export const useStyles = makeStyles((theme) => ({
    mainHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-end",
    },
    headCell: { fontWeight: 700, border: "5px solid black", color: "black" },
    head: { background: "#696969" },
  }));